// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__Pdhga","title":"ClientReferral_title__1wK3l","itemText":"ClientReferral_itemText__1tmFN"};